import React, { useState } from 'react';
import { Button, Dialog, DialogTitle, DialogActions, DialogContent, TextField } from '@mui/material';
import getThirtyDayAverages from '../../../../repository/getThirtyDayAverages';
import { useFormContext } from 'react-hook-form';

const PopulateComponentsButton = () => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const {
        formState: { errors, dirtyFields },
        watch,
        setError,
        clearErrors,
        getValues,
        setValue,
        selectedValues,
        updateSelectedValues,
        // wrap
    } = useFormContext();

    const handleOpenDialog = () => {
        setIsDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setIsDialogOpen(false);
    };

    const handlePopulateComponents = async () => {
        const { producer_id, tank, date } = getValues();
        const producerId = producer_id;
        const tankNum = tank;
        const selectedDate = date.format();

        try {
            const labAverages = await getThirtyDayAverages(producerId, tankNum, selectedDate);
            setValue('fat', Math.round(labAverages.averageFat * 10000) / 10000);
            setValue('protein', Math.round(labAverages.averageProtein * 10000) / 10000);
            setValue('lactose', Math.round(labAverages.averageLactose * 10000) / 10000);
            setValue('somatic_cell_count', Math.round(labAverages.averageScc * 10000) / 10000);
            setValue('solids_not_fat', Math.round(labAverages.averageSNF * 10000) / 10000);

            handleCloseDialog();
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    };

    return (
        <div>
            <Button variant="contained" color="secondary" onClick={handleOpenDialog}>
                Populate Components from Average Values?
            </Button>
            <Dialog open={isDialogOpen} onClose={handleCloseDialog}>
                <DialogTitle>Are you sure you want to populate components from average values?</DialogTitle>
                <DialogContent>
                    <p>This action will populate components with the average values.</p>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} variant="outlined" color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handlePopulateComponents} variant="contained" color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default PopulateComponentsButton;
